export default function BuildFooter() {
  return (
    <footer className="text-[10px] text-slate-400 dark:text-slate-600 text-center py-2 select-none">
      {__BUILD_SHA__} · {__BUILD_DATE__}
    </footer>
  );
}
